var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { uppercaseOnlyFirstLetter } from '../_shared/graph/graph.utils';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var CustomizedXAxisTick = function (props) {
    var x = props.x, y = props.y, payload = props.payload, dataSource = props.dataSource, XAxisCustomizedTickLabel = props.XAxisCustomizedTickLabel, index = props.index;
    return (_jsxs("g", __assign({ transform: "translate(".concat(x, ",").concat(y, ")"), style: { position: 'relative', width: '2rem' } }, { children: [_jsx("text", __assign({ x: -20, y: 16 }, { children: _jsx("tspan", { children: uppercaseOnlyFirstLetter(payload.value) }) })), index === 0 && (_jsx("text", __assign({ x: -20, y: 36 }, { children: _jsx("tspan", __assign({ className: "bold" }, { children: XAxisCustomizedTickLabel })) }))), index > 0 && !!payload.value && (_jsx("text", __assign({ x: -20, y: 36 }, { children: _jsx("tspan", __assign({ className: "bold" }, { children: dataSource[index].customizedTickValue })) })))] })));
};
export default CustomizedXAxisTick;
